<template>
    <el-alert
      :title="title"
      :type="type"
      :description="description"
      :closable="false"
      show-icon
    >
      <slot/>
    </el-alert>
</template>

<script>

    export default {
        name:"ed-alert",
        components:{},
        mixins:[],
        props:{
          title:{
            type:String,
            default:''
          },
          type:{
            type:String,
            default:'success'
          },
          description:{
            type:String,
            default:''
          },

        },
        watch:{
          title(){
          },
          type(){
          },
          description(){
          },
        },

        data() {
          return {
            showModal:false,
          }
        },
        mounted() {
        },
      
        methods:{

        }
    }
</script>


// WEBPACK FOOTER //
// alert.vue?09e3df73